import { Accordion, Box, Dialog, DialogActions, DialogContent, DialogTitle, Modal } from "@mui/material";
import Grid from '@mui/material/Grid2'
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { BoxModalCustom } from "../Theme/ContainerStyle";

export const ModalCustom = ({children, open, onClose, id, renderButton, sxStyle}) => {

  return(
    <Accordion>
      <Modal  disableAutoFocus
              open={open}
              onClose={onClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description">
        <BoxModalCustom sx={sxStyle}>
          <Grid container size={12} justifyContent="center" alignItems="center" sx={{ flexWrap: "nowrap"}}>
            <Grid container size={12}>
              {children && <Grid container size={12} key={id}>
                {children}
              </Grid>}
              {renderButton && renderButton}
            </Grid>
          </Grid>
        </BoxModalCustom>
      </Modal>
    </Accordion>
  )
};

export const DialogCustom = (props) => {
  const {open, onClose, title, renderBody, renderButton} = props
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box>
            {renderBody}
          </Box>
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        {renderButton}
      </DialogActions>
    </Dialog>
  )
}
